module.exports = __webpack_public_path__ + "static/small_biz-9f778e0070bf828858ecb9adb4660ecb.png";